// extracted by mini-css-extract-plugin
module.exports = {"courseContainer":"CourseCard_courseContainer__1sOUN","courseText":"CourseCard_courseText__2vqvw","courseDetail":"CourseCard_courseDetail__1HHKO"};